"use client";

/**
 * <ModalPortal> — wrapper koji renderuje children kroz React.createPortal u
 * document.body. Eskapira sve parent stacking context-e (npr. AdminTopbar
 * sticky top-0 z-20, sidebar fixed z-30) tako da modal backdrop pokriva
 * cijelu stranicu, uključujući topbar.
 *
 * Velibor 2026-05-06: bez ovoga modali su prikazivali bijelu liniju u
 * vrhu (topbar nije bio prekriven blur backdrop-om).
 *
 * Upotreba:
 *   <ModalPortal>
 *     <div className="fixed inset-0 z-[1000] ...">...</div>
 *   </ModalPortal>
 *
 * VAŽNO: zIndex children-a treba biti >= 1000 (iznad sidebar z-30, topbar
 * z-20, dropdowns z-50).
 */

import * as React from "react";
import { createPortal } from "react-dom";

export interface ModalPortalProps {
  children: React.ReactNode;
}

export function ModalPortal({ children }: ModalPortalProps) {
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || typeof document === "undefined") return null;
  return createPortal(children, document.body);
}
